// @docs:
//   - docs/wip/CREW_PAPER_REQUESTS.md  § Crew sign-in (papers-only account)
// ==============================================
// Who lands on "My papers" (/papers) instead of the MyPolaris dashboard: a
// crew member who signed in from a request link and has nothing else — no
// plan, no vessel, no subscription, no device — but has a request or papers.
// Everyone else keeps the dashboard exactly as before; a brand-new account
// with no request is left alone because it may be here to buy a plan.
// When anything cannot be read, the answer is "not papers-only" (the old path).
// ==============================================

import type { MeAccess } from './types';

export interface PapersOnlyInput {
  access: MeAccess | undefined;
  usage: { package?: unknown; subscription?: unknown; device_count?: number } | undefined | null;
  myPaperCount: number;
}

export function isPapersOnly({ access, usage, myPaperCount }: PapersOnlyInput): boolean {
  if (!access || !usage) return false;
  if (access.hasPlan || access.vesselCount > 0) return false;
  if (usage.package || usage.subscription || (usage.device_count ?? 0) > 0) return false;
  return access.recipientRequests > 0 || myPaperCount > 0;
}
